/* OXXRING v2 custom O-ring configurator: builds a specification, live summary, listed-size check, RFQ hand-off. */
(function () {
  'use strict';
  // Typical density (g/cm3) per family, median of anonymised compound records; for planning estimates only.
  var SG = { NBR: 1.27, FKM: 1.87, EPDM: 1.18, VMQ: 1.26, FFKM: 1.98, HNBR: 1.26, FVMQ: 1.53, FEPM: 1.65, CR: 1.40, PU: 1.23 };
  var SOLD = { NBR: 'N', FKM: 'F', EPDM: 'E', VMQ: 'S', FFKM: 'K' };
  var NAMES = { NBR: 'NBR', FKM: 'FKM', EPDM: 'EPDM', VMQ: 'Silicone (VMQ)', FFKM: 'FFKM', HNBR: 'HNBR', FVMQ: 'FVMQ', FEPM: 'FEPM (TFE/P)', CR: 'CR', PU: 'PU', HELP: 'to be recommended' };
  var FIELDS = ['id', 'cs', 'unit', 'dash', 'material', 'hardness', 'color', 'process', 'quantity', 'repeat', 'urgency', 'motive', 'application'];

  function num(v) { var s = String(v || '').trim().replace(',', '.'); return /^\d+(\.\d+)?$/.test(s) ? parseFloat(s) : NaN; }
  function f(n, d) { return Number(n).toFixed(d); }
  function el(tag, cls, text) { var n = document.createElement(tag); if (cls) n.className = cls; if (text != null) n.textContent = text; return n; }

  function init(root) {
    if (root.dataset.icReady) return; root.dataset.icReady = '1';
    var form = root.querySelector('[data-ic-cfg-form]');
    var X = window.OXXIC;
    var as568 = null, index = null, seq = 0, timer;

    function read() {
      var d = {};
      FIELDS.forEach(function (k) {
        var e = form.elements[k]; if (!e) return;
        d[k] = (e.length && !e.tagName) ? ([].slice.call(e).filter(function (r) { return r.checked; })[0] || {}).value || '' : e.value;
      });
      d.unknown = form.elements.unknown_size.checked;
      d.reqs = [].slice.call(form.querySelectorAll('input[name="reqs"]:checked')).map(function (c) { return c.value; });
      var k = d.unit === 'in' ? 25.4 : 1;
      d.idmm = num(d.id) * k; d.csmm = num(d.cs) * k; d.qty = parseInt(String(d.quantity).replace(/[^\d]/g, ''), 10) || 0;
      if (!(d.idmm > 0 && d.csmm > 0) && d.dash && as568) {
        var dn = ('00' + String(d.dash).replace(/[^\d]/g, '')).slice(-3);
        var row = as568.rows.filter(function (r) { return r.d === dn; })[0];
        if (row) { d.idmm = row.im; d.csmm = row.cm; d.dashN = dn; }
      }
      return d;
    }

    function advice(d) {
      if (!(d.idmm > 0 && d.csmm > 0)) return { rec: '', text: 'Enter a size and we suggest a construction.' };
      var big = d.idmm >= 600, mid = d.idmm >= 250;
      var rec = (big || (mid && d.qty && d.qty < 100)) ? 'spliced' : 'molded';
      var txt = rec === 'spliced'
        ? 'Suggested: spliced (vulcanized joint). At ' + f(d.idmm, 0) + ' mm ID' + (d.qty ? ' and ' + d.qty + ' pieces' : '') + ', a spliced ring avoids tooling. Best for static seals; say so if the seal is dynamic.'
        : 'Suggested: molded. At ' + f(d.idmm, 1) + ' mm ID a molded seamless ring is usual. If the size needs new tooling, the offer will show it.';
      if (d.process && d.process !== 'auto' && d.process !== rec) txt += ' You chose ' + d.process + '; we will quote that and note any trade-off.';
      return { rec: rec, text: txt };
    }

    function plates(d, adv) {
      var dl = root.querySelector('[data-ic-cfg-plates]'); dl.replaceChildren();
      function add(label, value, mono, sub) { var w = el('div', 'ic-cfg__plate'); w.appendChild(el('dt', null, label)); var dd = el('dd', mono ? 'ic-num' : null, value); if (sub) dd.appendChild(el('small', null, sub)); w.appendChild(dd); dl.appendChild(w); }
      var has = d.idmm > 0 && d.csmm > 0;
      if (has) {
        add('ID', f(d.idmm, 2) + ' mm', true, f(d.idmm / 25.4, 3) + ' in');
        add('CS', f(d.csmm, 2) + ' mm', true, f(d.csmm / 25.4, 3) + ' in');
      } else if (d.unknown) add('Size', 'To be identified from drawing or sample');
      add('Material', NAMES[d.material] || d.material || '—');
      add('Hardness', d.hardness ? d.hardness + ' Shore A' : 'To be recommended', !!d.hardness);
      add('Construction', d.process === 'auto' ? (adv.rec ? 'Recommended: ' + adv.rec : 'To be recommended') : d.process);
      if (d.qty) add('Quantity', d.qty.toLocaleString('en-US') + ' pcs' + (d.repeat ? ' · ' + d.repeat.toLowerCase() : ''), true);
      if (d.urgency) add('Needed', d.urgency);
      if (has) {
        var cord = Math.PI * (d.idmm + d.csmm);
        var vol = Math.PI * Math.PI / 4 * d.csmm * d.csmm * (d.idmm + d.csmm); // torus volume, mm3
        var sg = SG[d.material];
        add('Cord length', f(cord, 1) + ' mm', true, 'centreline');
        if (sg) add('Est. weight', (vol / 1000 * sg < 1 ? f(vol / 1000 * sg, 2) : f(vol / 1000 * sg, 1)) + ' g / piece', true);
      }
      root.querySelector('[data-ic-cfg-title]').textContent = has
        ? f(d.idmm, 2) + ' × ' + f(d.csmm, 2) + ' mm' + (d.material && d.material !== 'HELP' ? ' · ' + d.material : '') + (d.hardness ? ' ' + d.hardness + 'A' : '')
        : (d.unknown ? 'Size from drawing or sample' : 'Enter a size to start');
      var barTitle = root.querySelector('[data-ic-cfg-bar-title]');
      if (barTitle) barTitle.textContent = has ? root.querySelector('[data-ic-cfg-title]').textContent : (d.unknown ? 'Size from sample' : 'No size yet');
    }

    function ring(d) {
      var svg = root.querySelector('[data-ic-ring]'); if (!svg) return;
      var has = d.idmm > 0 && d.csmm > 0;
      var idT = svg.querySelector('[data-ic-ring-id]'), csT = svg.querySelector('[data-ic-ring-cs]');
      // Short labels so the text sits inside the ring opening instead of crossing the band (B-rfq-custom-6).
      if (idT) idT.textContent = has ? 'ID ' + f(d.idmm, 2) + ' mm' : 'ID';
      if (csT) csT.textContent = has ? 'CS ' + f(d.csmm, 2) + ' mm' : 'CS';
      var band = svg.querySelector('[data-ic-ring-band]');
      if (band && has) {
        var w = Math.max(6, Math.min(64, d.csmm * 192 / (d.idmm + 2 * d.csmm)));
        band.setAttribute('stroke-width', w.toFixed(1)); band.setAttribute('r', (96 - w / 2).toFixed(1));
        var sh = svg.querySelector('[data-ic-ring-shine]'); if (sh) { sh.setAttribute('r', (96 - w / 2).toFixed(1)); sh.setAttribute('stroke-width', (w * .3).toFixed(1)); }
        var ln = svg.querySelector('[data-ic-ring-id-line]'); if (ln) { ln.setAttribute('x1', (140 - (96 - w)).toFixed(1)); ln.setAttribute('x2', (140 + (96 - w)).toFixed(1)); }
      }
    }

    function listed(d) {
      var box = root.querySelector('[data-ic-cfg-listed]');
      if (!(d.idmm > 0 && d.csmm > 0) || !X) { box.hidden = true; return; }
      var run = ++seq;
      X.sizeIndex(root.dataset.indexUrl).then(function (ix) {
        if (run !== seq) return; index = ix;
        var rows = X.exact(ix, d.idmm, d.csmm);
        box.replaceChildren();
        if (!rows.length) {
          var near = X.nearby(ix, d.idmm, d.csmm, 4);
          if (!near.length) { box.hidden = true; return; }
          box.className = 'ic-cfg__listed ic-cfg__listed--near';
          box.appendChild(el('p', null, 'Not a listed size. Nearby listed sizes, for comparison only (not equivalents):'));
          var ul = el('ul');
          near.forEach(function (n) { var li = el('li'); var a = el('a', 'ic-chip', f(n.row.id, 2) + ' × ' + f(n.row.cs, 2) + ' mm'); a.href = '/pages/size-guide?view=find-o-rings&units=mm&id=' + f(n.row.id, 2) + '&cs=' + f(n.row.cs, 2) + '&source=configurator-nearby'; li.appendChild(a); ul.appendChild(li); });
          box.appendChild(ul); box.hidden = false; return;
        }
        var codes = rows[0].codes, want = SOLD[d.material];
        var match = want ? codes.filter(function (c) { return c.m === want && (!d.hardness || c.h === d.hardness); }) : [];
        box.className = 'ic-cfg__listed ic-cfg__listed--ok';
        var h = el('p'); h.appendChild(el('strong', null, 'Good news: this size is already listed'));
        h.appendChild(document.createTextNode(' in ' + codes.length + ' material / hardness grades' + (match.length ? ', including your choice.' : '.') + ' Standard grades ship in small packs without a custom run.'));
        box.appendChild(h);
        var ul2 = el('ul');
        (match.length ? match : codes).slice(0, 8).forEach(function (c) {
          var li = el('li'); var a = el('a', 'ic-chip', X.MAT[c.m][0] + ' ' + c.h + 'A'); a.href = '/products/' + X.handleFor(ix, rows[0], c); li.appendChild(a); ul2.appendChild(li);
        });
        box.appendChild(ul2);
        var more = el('a', 'ic-link', 'Compare all grades in the size finder →'); more.href = '/pages/size-guide?view=find-o-rings&units=mm&id=' + f(rows[0].id, 2) + '&cs=' + f(rows[0].cs, 2) + '&source=configurator'; box.appendChild(more);
        box.hidden = false;
      });
    }

    function summary(d, adv) {
      var lines = ['Custom O-ring specification'];
      if (d.idmm > 0 && d.csmm > 0) lines.push('Size: ' + f(d.idmm, 2) + ' x ' + f(d.csmm, 2) + ' mm' + (d.dashN ? ' (AS568-' + d.dashN + ')' : '') + (d.unit === 'in' ? ' [entered in inches: ' + d.id + ' x ' + d.cs + ']' : ''));
      else if (d.unknown) lines.push('Size: unknown, to identify from drawing/sample');
      lines.push('Material: ' + (NAMES[d.material] || '-') + '; hardness: ' + (d.hardness ? d.hardness + ' Shore A' : 'recommend') + (d.color ? '; colour: ' + d.color : ''));
      lines.push('Construction: ' + (d.process === 'auto' ? 'recommend (suggested ' + (adv.rec || '-') + ')' : d.process));
      if (d.reqs.length) lines.push('Documents/conditions: ' + d.reqs.join(', '));
      if (d.qty) lines.push('Quantity: ' + d.qty + ' pcs' + (d.repeat ? ', repeat ' + d.repeat.toLowerCase() : ''));
      if (d.urgency) lines.push('Needed: ' + d.urgency);
      if (d.motive) lines.push('Reason: ' + d.motive);
      if (d.application) lines.push('Application: ' + d.application.slice(0, 400));
      return lines.join('\n');
    }

    function links(d, adv) {
      var p = new URLSearchParams({ source: 'configurator', request_mode: d.unknown && !(d.idmm > 0) ? 'NEED_HELP' : 'CUSTOM' });
      if (d.idmm > 0 && d.csmm > 0) { p.set('id', f(d.idmm, 2)); p.set('cs', f(d.csmm, 2)); p.set('units', 'mm'); }
      if (d.dashN) { p.set('standard', 'AS568'); p.set('standard_code', '-' + d.dashN); }
      if (d.material && d.material !== 'HELP') p.set('material', d.material);
      if (d.hardness) p.set('hardness', d.hardness + 'A');
      if (d.qty) p.set('quantity', String(d.qty));
      if (d.application) p.set('application', d.application.slice(0, 200));
      var ctx = summary(d, adv); p.set('context', ctx.slice(0, 1500));
      root.querySelector('[data-ic-cfg-send]').href = root.dataset.rfqUrl + '?' + p.toString();
      var barSend = root.querySelector('[data-ic-cfg-bar-send]');
      if (barSend) barSend.href = root.dataset.rfqUrl + '?' + p.toString();
      var wa = root.querySelector('[data-ic-cfg-wa]');
      if (wa) wa.href = 'https://wa.me/' + root.dataset.whatsapp + '?text=' + encodeURIComponent(ctx.slice(0, 900));
      // Shareable state
      var s = new URLSearchParams(location.search); s.set('view', 'custom');
      FIELDS.forEach(function (k) { if (d[k] && !(k === 'process' && d[k] === 'auto') && !(k === 'unit' && d[k] === 'mm') && k !== 'application') s.set('c_' + k, d[k]); else s.delete('c_' + k); });
      history.replaceState(null, '', location.pathname + '?' + s.toString());
    }

    function update() {
      var d = read(), adv = advice(d);
      root.querySelector('[data-ic-cfg-advice]').textContent = adv.text;
      plates(d, adv); ring(d); links(d, adv);
      clearTimeout(timer); timer = setTimeout(function () { listed(d); }, 250);
    }

    // Restore from URL (?c_id=...), including values passed by other tools (?id=&cs=&material=).
    var q = new URLSearchParams(location.search);
    FIELDS.forEach(function (k) {
      var v = q.get('c_' + k) || (['id', 'cs', 'material', 'hardness', 'quantity'].indexOf(k) > -1 ? q.get(k) : null);
      if (v == null) return;
      var e = form.elements[k]; if (!e) return;
      if (e.length && !e.tagName) [].slice.call(e).forEach(function (r) { r.checked = r.value === v || (k === 'material' && r.value === String(v).toUpperCase()); });
      else e.value = v;
    });
    if (q.get('process') && form.elements.process) [].slice.call(form.elements.process).forEach(function (r) { r.checked = r.value === q.get('process'); });

    form.addEventListener('input', update);
    form.addEventListener('change', update);
    form.addEventListener('submit', function (e) { e.preventDefault(); });
    root.querySelector('[data-ic-cfg-copy]').addEventListener('click', function (e) {
      var b = e.currentTarget;
      (navigator.clipboard ? navigator.clipboard.writeText(location.href) : Promise.reject()).then(function () { b.lastChild.textContent = 'Link copied'; }).catch(function () { b.lastChild.textContent = 'Copy from address bar'; });
    });
    var dashNeeded = !!q.get('c_dash');
    (X && (dashNeeded || true) ? X.loadJSON(root.dataset.as568Url).then(function (a) { as568 = a; }).catch(function () {}) : Promise.resolve()).then(update);
    update();

    // Below 1100 px the summary sits after the form; a bottom bar keeps the quote action in reach until it is visible.
    var bar = root.querySelector('[data-ic-cfg-bar]'), sumCard = root.querySelector('.ic-cfg__sum');
    if (bar && sumCard && 'IntersectionObserver' in window) {
      var formSeen = false, sumSeen = false;
      var sync = function () { bar.hidden = !formSeen || sumSeen; };
      new IntersectionObserver(function (es) { es.forEach(function (e) { sumSeen = e.isIntersecting; }); sync(); }).observe(sumCard);
      new IntersectionObserver(function (es) { es.forEach(function (e) { formSeen = e.isIntersecting || e.boundingClientRect.top < 0; }); sync(); }).observe(form);
    }
  }

  function boot() { document.querySelectorAll('[data-ic-cfg]').forEach(init); }
  if (window.OXXIC) boot(); else document.addEventListener('DOMContentLoaded', boot);
})();
